import React from 'react';
import Block from '../../design-system/chat-blocks/Block';
import Pill from '../../design-system/primitives/Pill';
import Expandable, { expandedMaxHeight } from './Expandable';
import { fmtInt, relTime } from './format';

const MembersTable = ({ members, onSelect }) => (
  <Expandable>{(expanded) => (
  <Block icon="users" title="Members" badge={<Pill tone="neutral">{members.length}</Pill>} footer={<span style={{ flex: 1 }} />}>
    <div className="qa-table-wrap" style={{ maxHeight: expanded ? expandedMaxHeight : 320 }}>
      <table className="qa-table qa-table--clickable">
        <thead>
          <tr>
            <th>User</th><th>Last active</th><th>Last login</th>
            <th className="qa-r">Analyses</th><th className="qa-r">API calls</th><th className="qa-r">Chat msgs</th><th className="qa-r">API keys</th>
          </tr>
        </thead>
        <tbody>
          {members.map((m) => (
            <tr key={m.id} onClick={() => onSelect({ type: 'user', id: m.id })} tabIndex={0}
              onKeyDown={(e) => { if (e.key === 'Enter') onSelect({ type: 'user', id: m.id }); }}>
              <td>
                <div className="qa-cell-title">{m.full_name || m.username}
                  {m.is_primary_contact && <Pill tone="outline" style={{ padding: '1px 7px', fontSize: 10.5 }}>primary</Pill>}
                  {m.is_staff && <Pill tone="accent" style={{ padding: '1px 7px', fontSize: 10.5 }}>staff</Pill>}
                </div>
                <div className="qa-cell-sub">{m.email}</div>
              </td>
              <td className="qa-mono">{relTime(m.last_activity_at)}</td>
              <td className="qa-mono">{relTime(m.last_login)}</td>
              <td className="qa-r qa-mono">{fmtInt(m.analyses_total)}</td>
              <td className="qa-r qa-mono">{fmtInt(m.sdk_jobs_total)}</td>
              <td className="qa-r qa-mono">{fmtInt(m.chat_messages_total)}</td>
              <td className="qa-r qa-mono">{fmtInt(m.active_api_keys)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </Block>
  )}</Expandable>
);

export default MembersTable;
